[
  {
    "code": "TECH",
    "label": {
      "en": "Technology & Software",
      "es": "Tecnologia y Software"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "icon": "mdi:laptop"
    }
  },
  {
    "code": "FINANCE",
    "label": {
      "en": "Finance & Banking",
      "es": "Finanzas y Banca"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "icon": "mdi:bank"
    }
  },
  {
    "code": "HEALTHCARE",
    "label": {
      "en": "Healthcare & Pharma",
      "es": "Salud y Farmacia"
    },
    "order": 3,
    "is_active": true,
    "metadata": {
      "icon": "mdi:hospital"
    }
  },
  {
    "code": "EDUCATION",
    "label": {
      "en": "Education",
      "es": "Educacion"
    },
    "order": 4,
    "is_active": true,
    "metadata": {
      "icon": "mdi:school"
    }
  },
  {
    "code": "RETAIL",
    "label": {
      "en": "Retail & Commerce",
      "es": "Comercio y Retail"
    },
    "order": 5,
    "is_active": true,
    "metadata": {
      "icon": "mdi:store"
    }
  },
  {
    "code": "MANUFACTURING",
    "label": {
      "en": "Manufacturing",
      "es": "Manufactura"
    },
    "order": 6,
    "is_active": true,
    "metadata": {
      "icon": "mdi:factory"
    }
  },
  {
    "code": "CONSTRUCTION",
    "label": {
      "en": "Construction",
      "es": "Construccion"
    },
    "order": 7,
    "is_active": true,
    "metadata": {
      "icon": "mdi:hammer"
    }
  },
  {
    "code": "TRANSPORT",
    "label": {
      "en": "Transport & Logistics",
      "es": "Transporte y Logistica"
    },
    "order": 8,
    "is_active": true,
    "metadata": {
      "icon": "mdi:truck"
    }
  },
  {
    "code": "HOSPITALITY",
    "label": {
      "en": "Hospitality & Tourism",
      "es": "Hosteleria y Turismo"
    },
    "order": 9,
    "is_active": true,
    "metadata": {
      "icon": "mdi:bed"
    }
  },
  {
    "code": "REAL_ESTATE",
    "label": {
      "en": "Real Estate",
      "es": "Inmobiliaria"
    },
    "order": 10,
    "is_active": true,
    "metadata": {
      "icon": "mdi:home-city"
    }
  },
  {
    "code": "ENERGY",
    "label": {
      "en": "Energy & Utilities",
      "es": "Energia y Utilities"
    },
    "order": 11,
    "is_active": true,
    "metadata": {
      "icon": "mdi:lightning-bolt"
    }
  },
  {
    "code": "AGRICULTURE",
    "label": {
      "en": "Agriculture",
      "es": "Agricultura"
    },
    "order": 12,
    "is_active": true,
    "metadata": {
      "icon": "mdi:sprout"
    }
  },
  {
    "code": "MEDIA",
    "label": {
      "en": "Media & Entertainment",
      "es": "Medios y Entretenimiento"
    },
    "order": 13,
    "is_active": true,
    "metadata": {
      "icon": "mdi:television"
    }
  },
  {
    "code": "TELECOM",
    "label": {
      "en": "Telecommunications",
      "es": "Telecomunicaciones"
    },
    "order": 14,
    "is_active": true,
    "metadata": {
      "icon": "mdi:antenna"
    }
  },
  {
    "code": "CONSULTING",
    "label": {
      "en": "Consulting",
      "es": "Consultoria"
    },
    "order": 15,
    "is_active": true,
    "metadata": {
      "icon": "mdi:briefcase"
    }
  },
  {
    "code": "LEGAL",
    "label": {
      "en": "Legal Services",
      "es": "Servicios Legales"
    },
    "order": 16,
    "is_active": true,
    "metadata": {
      "icon": "mdi:gavel"
    }
  },
  {
    "code": "INSURANCE",
    "label": {
      "en": "Insurance",
      "es": "Seguros"
    },
    "order": 17,
    "is_active": true,
    "metadata": {
      "icon": "mdi:shield"
    }
  },
  {
    "code": "AUTOMOTIVE",
    "label": {
      "en": "Automotive",
      "es": "Automocion"
    },
    "order": 18,
    "is_active": true,
    "metadata": {
      "icon": "mdi:car"
    }
  },
  {
    "code": "FOOD",
    "label": {
      "en": "Food & Beverage",
      "es": "Alimentacion y Bebidas"
    },
    "order": 19,
    "is_active": true,
    "metadata": {
      "icon": "mdi:food"
    }
  },
  {
    "code": "OTHER",
    "label": {
      "en": "Other",
      "es": "Otros"
    },
    "order": 99,
    "is_active": true,
    "metadata": {
      "icon": "mdi:dots-horizontal"
    }
  }
]
